<template>
  <router-view></router-view>
</template>

<script>
export default {
  name: "sadqaFinancialAid",
  data() {
    return {};
  },
  created() {}
};
</script>
